import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>{t('terms.title')}</h1>
        <p className="last-updated">{t('terms.lastUpdated')}: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>{t('terms.acceptance.title')}</h2>
          <p>{t('terms.acceptance.text')}</p>
        </section>

        <section>
          <h2>{t('terms.use.title')}</h2>
          <p>{t('terms.use.text')}</p>
          <ul>
            <li>{t('terms.use.item1')}</li>
            <li>{t('terms.use.item2')}</li>
            <li>{t('terms.use.item3')}</li>
            <li>{t('terms.use.item4')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('terms.content.title')}</h2>
          <p>{t('terms.content.text')}</p>
          <p>{t('terms.content.text2')}</p>
        </section>

        <section>
          <h2>{t('terms.disclaimer.title')}</h2>
          <p>{t('terms.disclaimer.text')}</p>
          <p>{t('terms.disclaimer.text2')}</p>
        </section>

        <section>
          <h2>{t('terms.limitation.title')}</h2>
          <p>{t('terms.limitation.text')}</p>
        </section>

        <section>
          <h2>{t('terms.intellectual.title')}</h2>
          <p>{t('terms.intellectual.text')}</p>
        </section>

        <section>
          <h2>{t('terms.thirdParty.title')}</h2>
          <p>{t('terms.thirdParty.text')}</p>
        </section>

        <section>
          <h2>{t('terms.termination.title')}</h2>
          <p>{t('terms.termination.text')}</p>
        </section>

        <section>
          <h2>{t('terms.changes.title')}</h2>
          <p>{t('terms.changes.text')}</p>
        </section>

        <section>
          <h2>{t('terms.contact.title')}</h2>
          <p>{t('terms.contact.text')}</p>
          <p>
            <strong>{t('terms.contact.email')}</strong>: contact@dailyzodiac.ai<br />
            <strong>{t('terms.contact.website')}</strong>: <a href="https://dailyzodiac.ai">dailyzodiac.ai</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
